import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { ArrowChevronLeftMiniIcon } from '@calendly/ui/components/icons';
import { PageHeader } from '@calendly/ui/components/page-header';
import { Tab, Tabs } from '@calendly/ui/components/tabs';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
const mainCss = "m42yd2e";
export const Main = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'main';
  return <Component ref={ref} {...restProps} className={classNames(mainCss, props.className)} />;
});
const pageContentNewAdminIALayoutCss = "p1o6ontn";
const pageContentCss = "p1wnpnmf";
export const PageContent = forwardRef((props, ref) => {
  const {
    newAdminIALayout,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(pageContentCss, {
    [pageContentNewAdminIALayoutCss]: newAdminIALayout
  }, props.className)} />;
});
const subheaderCss = "s1kxuzmg";
export const Subheader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    children,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-component="subheader" className={classNames(subheaderCss, props.className)}>
      <PageContent>{children}</PageContent>
    </Component>;
});
const subheaderTitleCss = "sx1xg6g";
export const SubheaderTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h1';
  return <Component ref={ref} {...restProps} className={classNames(subheaderTitleCss, props.className)} />;
});
const mobileBackButtonCss = "mr7o340";
const MobileBackButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} aria-label={I18n.t('publisher.action.back')} className={classNames(mobileBackButtonCss, props.className)}>
    <ArrowChevronLeftMiniIcon size="x-large" />
  </BareButton>);
const desktopBackButtonCss = "d1q0bq50";
const DesktopBackButton = ({
  children,
  ...props
}) => <Button decoration="secondary-outline" {...props} className={classNames(desktopBackButtonCss, props.className)}>
    <ArrowChevronLeftMiniIcon />
    {children}
  </Button>;
export const BackButton = ({
  ...props
}) => {
  const isPhone = useDeviceType('isPhone');
  return isPhone ? <MobileBackButton as="a" {...props} /> : <DesktopBackButton as="a" {...props} />;
};
const navigationContainerIsPhoneCss = "ni6yg01";
const navigationContainerCss = "nxhyno3";
export const NavigationContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(navigationContainerCss, {
    [navigationContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const pageContainerIsTabletUpCss = "p1suz7lz";
export const pageContainerCss = "p4nu643";
export const PageContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(pageContainerCss, {
    [pageContainerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const tabContainerNarrowCss = "t107xmap";
const tabContainerCss = "t13nwvc0";
export const TabContainer = forwardRef((props, ref) => {
  const {
    narrow,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(tabContainerCss, {
    [tabContainerNarrowCss]: narrow && isTabletUp
  }, props.className)} />;
});
const tabContentCss = "t1ptbhq2";
export const TabContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tabContentCss, props.className)} />;
});
const occupancyRatioWrapperIsDesktopUpCss = "o11p9335";
const occupancyRatioWrapperIsAdminIaCss = "oo9vgzj";
const occupancyRatioWrapperCss = "oodjkv5";
const OccupancyRatioWrapper = forwardRef((props, ref) => {
  const {
    isAdminIa,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(occupancyRatioWrapperCss, {
    [occupancyRatioWrapperIsDesktopUpCss]: isDesktopUp,
    [occupancyRatioWrapperIsAdminIaCss]: isAdminIa
  }, props.className)} />;
});
export const OccupancyRatio = ({
  ratio,
  isAdminIa
}) => {
  const isMobile = useDeviceType('isPhone');
  const label = isMobile ? I18n.t('publisher.organization.members.seats_occupied_mobile') : I18n.t('publisher.organization.members.seats_occupied');
  if (!ratio) return null;
  return <OccupancyRatioWrapper isAdminIa={isAdminIa}>
      <BodyText inline size="medium" color="muted">
        {` ${ratio} ${label}`}
      </BodyText>
    </OccupancyRatioWrapper>;
};
const mobileContainerCss = "m177m2xk";
export const MobileContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileContainerCss, props.className)} />;
});
const eyebrowBackButtonContainerCss = "ewi0bxw";
const EyebrowBackButtonContainer = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(eyebrowBackButtonContainerCss, props.className)} />);
export const EyebrowBackButton = ({
  to,
  href,
  children,
  onClick,
  ...props
}) => {
  let as;
  if (href) as = 'a';
  if (to) as = RouterLink;
  return <EyebrowBackButtonContainer to={to} href={href} onClick={onClick} as={as} {...props}>
      {children}
    </EyebrowBackButtonContainer>;
};
const tabsWrapperHasBottomMarginCss = "t1tvnwtp";
const tabsWrapperCss = "tgkib76";
const TabsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    hasBottomMargin = true,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tabsWrapperCss, {
    [tabsWrapperHasBottomMarginCss]: hasBottomMargin
  }, props.className)} />;
});

/**
 * @param {object} props
 * @param {boolean} [props.hideTitleChrome] — when true, only the tab row is rendered (e.g. settings modal already shows section title).
 */
export const PageHeaderWithTabs = ({
  eyebrow,
  title: headerTitle,
  description,
  tabs,
  hideTitleChrome = false,
  actions,
  wide,
  hasBottomMargin = true,
  ...props
}) => {
  const tabList = tabs && <Tabs underlined aria-label={headerTitle || undefined}>
      {tabs.map(({
      key: tabKey,
      title,
      route,
      selected,
      onTabClick,
      ...tabProps
    }) => {
      const routeKey = typeof route === 'string' ? route : [route?.pathname, route?.search, route?.hash].filter(Boolean).join('');
      return <Tab key={tabKey ?? routeKey} as={RouterLink} to={route} onClick={onTabClick} selected={selected} {...tabProps}>
            {title}
          </Tab>;
    })}
    </Tabs>;
  if (hideTitleChrome) {
    return <TabsWrapper {...props} hasBottomMargin={hasBottomMargin}>
        {tabList}
      </TabsWrapper>;
  }
  return <TabsWrapper {...props} hasBottomMargin={hasBottomMargin}>
      <PageHeader wide={wide} eyebrow={eyebrow} title={headerTitle || ''} description={description} tabs={tabList} actions={actions} />
    </TabsWrapper>;
};
const learnMoreButtonCss = "ld9gl3b";
export const LearnMoreButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(learnMoreButtonCss, props.className)} />);

require("./page_elements.wyw-in-js.css!=!../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./page_elements.js");